import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { stiRatesService, UpdateStiRateEntry } from '../../services/customers/stiRatesService'
import { showSuccessToast, showErrorToast } from '../../utils/errorHandler'

export const useStiRates = (customerId: string, enabled = true) => {
  return useQuery({
    queryKey: ['sti-rates', customerId],
    queryFn: () => stiRatesService.getStiRates(customerId),
    enabled: !!customerId && enabled,
  })
}

export const useUpdateStiRates = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      customerId,
      rates,
    }: {
      customerId: string
      rates: UpdateStiRateEntry[]
    }) => stiRatesService.updateStiRates(customerId, rates),
    onSuccess: (_, { customerId }) => {
      queryClient.invalidateQueries({ queryKey: ['sti-rates', customerId] })
      queryClient.invalidateQueries({ queryKey: ['customer', customerId] })
      showSuccessToast('STI rates updated successfully!')
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}
